import React, {Suspense, useMemo} from "react";
import {RouterProvider, createBrowserRouter, createRoutesFromElements, Route} from "react-router-dom";
import authRoutes from "../config/authRoutes";
import guestRoutes from "../config/guestRoutes";
import Error from "../pages/error/Error"

const RoutesBuilder = () => {
    const router = useMemo(() => createBrowserRouter(
        createRoutesFromElements(
            <>
                {guestRoutes}
                {authRoutes}
                <Route path="*" element={<Error/>}/>
            </>
        )
    ), [])

    return (
        <RouterProvider router={router}/>
    );
};

export default RoutesBuilder;
